import { ExitFormDialogContext } from "@dashboard/components/Form/ExitFormDialogProvider";
import { history, isAtEntryLocation } from "@dashboard/components/Router";
import { useCallback, useContext } from "react";

import { isDetailPopupWindow } from "./consts";

// 상세 팝업 창의 뒤로가기 (2026-10-10 KST 추가). 상단 ← 과 하단 바 버튼이 같이 쓴다.
// 팝업에는 메뉴가 없어 목록으로 가면 갈 곳이 없으므로, 처음 연 페이지에서는 창을 닫고
// 팝업 안에서 다른 페이지로 옮겨 간 뒤에는 직전 페이지로 돌아간다.
// 팝업이 아니면 아무것도 하지 않고 false 를 돌려준다.
export const usePopupBack = () => {
  const { requestWindowClose } = useContext(ExitFormDialogContext);

  return useCallback((): boolean => {
    if (!isDetailPopupWindow()) {
      return false;
    }

    if (isAtEntryLocation()) {
      requestWindowClose();
    } else {
      history.goBack();
    }

    return true;
  }, [requestWindowClose]);
};
